import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navRouter: 'index',
    navRouterName: '申请公示',
    typeId: 0
  },
  mutations: {
    updateNavRouter (state, navRouter) {
      switch (navRouter) {
        case 'index':
          state.navRouter = navRouter
          state.navRouterName = '申请公示'
          state.typeId = 1
          break
        case 'siteBook':
          state.navRouter = navRouter
          state.navRouterName = '亮照告知书'
          state.typeId = 2
          break
        case 'applyStep':
          state.navRouter = navRouter
          state.navRouterName = '申请步骤'
          state.typeId = 3
          break
        case 'signApply':
          state.navRouter = navRouter
          state.navRouterName = '电子标识申请'
          state.typeId = 4
          break
      }
    },
    updateTypeId (state, typeId) {
      state.typeId = typeId
      switch (parseInt(typeId)) {
        case 1:
          state.navRouterName = '专业测评'
          state.navRouter = 'index'
          break
        case 2:
          state.navRouterName = '趣味测评'
          state.navRouter = 'siteBook'
          break
        case 3:
          state.navRouterName = '申请步骤'
          state.navRouter = 'applyStep'
          break
        case 4:
          state.navRouterName = '电子标识申请'
          state.navRouter = 'signApply'
          break
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js